import React from 'react';
import { Text, Section, Link } from '@react-email/components';
import Layout, { LayoutTranslations } from './components/Layout';

export interface PaymentRejectedTranslations {
  title: string;
  greeting: string;
  body: string;
  labelAmount: string;
  reasonLabel: string;
  actionRetry: string;
  ctaText: string;
  contactSupport: string;
  signOff: string;
  teamSignature: string;
  layout: LayoutTranslations;
}

interface PaymentRejectedProps {
  name: string;
  amount: string;
  reason: string;
  translations: PaymentRejectedTranslations;
}

export default function PaymentRejected({
  name,
  amount,
  reason,
  translations: tx,
}: PaymentRejectedProps) {
  return (
    <Layout previewText={tx.title} translations={tx.layout}>
      <Text style={heading}>{tx.title}</Text>
      <Text style={paragraph}>{tx.greeting} <strong>{name}</strong>,</Text>
      <Text style={paragraph}>{tx.body}</Text>

      <Section style={infoBox}>
        <Text style={infoLine}>
          <span style={infoLabel}>{tx.labelAmount}:</span> {amount}
        </Text>
        <Text style={infoLine}>
          <span style={infoLabel}>{tx.reasonLabel}:</span> {reason}
        </Text>
      </Section>

      <Text style={paragraph}>{tx.actionRetry}</Text>

      <Section style={ctaContainer}>
        <Link href="https://siportevent.com/visitor/dashboard" style={ctaButton}>
          {tx.ctaText}
        </Link>
      </Section>

      <Text style={supportText}>{tx.contactSupport}: <Link href="mailto:contact@siportevent.com" style={supportLink}>contact@siportevent.com</Link></Text>
      <Text style={paragraph}>{tx.signOff}<br />{tx.teamSignature}</Text>
    </Layout>
  );
}

const heading: React.CSSProperties = { fontSize: '24px', fontWeight: 700, color: '#dc2626', margin: '0 0 20px 0' };
const paragraph: React.CSSProperties = { fontSize: '16px', lineHeight: '1.6', color: '#374151', margin: '0 0 16px 0' };
const infoBox: React.CSSProperties = { backgroundColor: '#fef2f2', padding: '20px', borderRadius: '8px', margin: '20px 0', border: '1px solid #fecaca' };
const infoLine: React.CSSProperties = { fontSize: '15px', color: '#1f2937', margin: '0 0 10px 0' };
const infoLabel: React.CSSProperties = { color: '#6b7280' };
const ctaContainer: React.CSSProperties = { textAlign: 'center' as const, margin: '30px 0' };
const ctaButton: React.CSSProperties = { display: 'inline-block', padding: '14px 28px', backgroundColor: '#dc2626', color: '#ffffff', textDecoration: 'none', borderRadius: '8px', fontWeight: 600, fontSize: '16px' };
const supportText: React.CSSProperties = { fontSize: '14px', color: '#6b7280', textAlign: 'center' as const, margin: '0 0 20px 0' };
const supportLink: React.CSSProperties = { color: '#2563eb', textDecoration: 'underline' };
